import {
  ArrowBack,
  ArrowForward,
  CancelScheduleSend,
  CurrencyRupeeSharp,
  Edit,
  MoreVert,
  Preview,
  VerifiedOutlined,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Pagination,
  PaginationItem,
  Skeleton,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import dayjs from "dayjs";
import * as React from "react";
import { useEffect, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDataGrid from "../../CustomComponents/CustomDataGrid";
import GetBranchDetails from "../../CustomComponents/GetBranchDetails";
import NoDataFound from "../../CustomComponents/NoDataFound";
import StlapFooter from "../../CustomComponents/StlapFooter";
import { BranchAction } from "../../Store/Branch";
import { DisbursementRequestListService } from "./DisbursementRequestListService";
import FilterCondition from "./FilterCondition";
import { DisbursementBalanceTransferReducerAction } from "../../Store/DisbursementBalanceTransfer/DisbursementBalanceTransferReducer";
import { useRef } from "react";
import { CommonShortCutAction } from "../../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../../CustomComponents/GetBranchDetailsWithCode";
import ConvertBase64ToFile from "../../CustomComponents/ConvertBase64ToFile";

export default function DisbursementRequestList(props) {
  const cancelRef = useRef(null);
  const okRef = useRef(null);
  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);

  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      cancelRef: cancelRef,
      okRef: okRef,
      searchButtonRef: searchButtonRef,
      clearRef: clearRef,
    };
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "disbursementRequestList",
        })
      );
      //}
    }
  };
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "disbursementRequestList",
        })
      );
    }
  };

  const columns = [
    // {
    //   field: "requestNumber",
    //   headerName: "Request Number",
    //   headerAlign: "center",
    //   type: "string",
    //   flex: 200,
    //   align: "left",
    //   hideable: false,
    // },
    {
      field: "branch",
      headerName: "Branch Name",
      headerAlign: "center",
      type: "string",
      flex: props.mode === "REQUESTLIST" ? 220 : 180,
      align: "left",
    },
    {
      field: "applicationNum",
      headerName: "Application Number",
      headerAlign: "center",
      type: "string",
      hideable: false,
      flex: props.mode === "REQUESTLIST" ? 220 : 180,
      align: "left",
    },
    {
      field: "customerName",
      headerName: "Applicant Name",
      headerAlign: "center",
      type: "string",
      flex: props.mode === "REQUESTLIST" ? 260 : 200,
      align: "left",
      sortable: false,
    },
    {
      field: "disbAmt",
      headerName: "Disbursement Amount",
      headerAlign: "center",
      type: "string",
      flex: props.mode === "REQUESTLIST" ? 220 : 180,
      align: "right",
      sortable: false,
      renderHeader: (params) => {
        return (
          <>
            {"Disbursement Amount("} <CurrencyRupeeSharp fontSize="small" />{" "}
            {")"}
          </>
        );
      },
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },

    {
      field: "disbursementStatus",
      headerName: "Status",
      headerAlign: "center",
      type: "string",
      flex: props.mode === "REQUESTLIST" ? 300 : 270,
      align: "left",
      sortable: false,
      renderCell: (params) => {
        return loadStatus(params.value);
      },
    },
    // {
    //   field: "disbursementDate",
    //   headerName: "Disbursement Date",
    //   headerAlign: "center",
    //   type: "string",
    //   flex: 140,
    //   align: "right",
    // },
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      type: "string",
      flex: props.mode === "REQUESTLIST" ? 120 : 90,
      align: "center",
      hideable: false,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <LoadActionBtn
            record={params.row}
            setResponseData={setResponseData}
            setopenViewConfirmation={setopenViewConfirmation}
            listScreenMode={listScreenMode}
          />
        );
      },
    },
    {
      field: "approvedOn",
      headerName: "Approved On",
      headerAlign: "center",
      type: "string",
      flex: 130,
      align: "right",
      filterable: false,
      sortable: false,
    },
    {
      field: "approvedBy",
      headerName: "Approved By",
      headerAlign: "center",
      type: "string",
      flex: 130,
      align: "left",
      sortable: false,
    },
  ];

  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    approvedOn: props.mode !== "REQUESTLIST",
    approvedBy: props.mode !== "REQUESTLIST",
  });

  var today = new Date();

  const initialState = {
    tabIndex: "2",
    disbursementList: [],
    sanctionList: [],
    branchNames: [],
    branch: null,
    applicationNum: "",
    customerName: "",
    coApplicantName: "",
    customerId: "",
    sanctionStatus: "",
    effectiveDate: dayjs(
      today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear()
    ).format("DD/MM/YYYY"),
    applicationDateFromValue: dayjs(
      today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear()
    ).format("DD/MM/YYYY"),
    applicationDateToValue: dayjs(
      today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear()
    ).format("DD/MM/YYYY"),
    applicationDate: null,
    customerType: "-1",
    rateOfInterest: "",
    loanAmt: "",
    sanctionAmt: "",

    disbursementDateFromValue: null,
    disbursementDateToValue: dayjs(
      today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear()
    ).format("DD/MM/YYYY"),
    disbursementStatus: "",
    requestNumber: "",
    screenModeTitle: "",
  };

  const [datarows, setdatarows] = React.useState([]);
  const [accordianOpen, setAccordianOpen] = React.useState(true);

  const [rows, setRows] = React.useState([]);
  // default sort to be in applciationnum.
  const [sortConditions, setSortConditions] = React.useState([]);
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  // total record for available from server to avoid duplicate on last request.
  const [totalRecordsCount, setTotalRecordsCount] = React.useState(0);
  const [branchNames, setTotalBranchNames] = React.useState([]);
  const [filterConditionState, setFilterConditionState] =
    React.useState(initialState);
  const [openViewConfirmation, setopenViewConfirmation] = React.useState(false);
  const [responseData, setResponseData] = React.useState({});
  const [listScreenMode, setListScreenMode] = React.useState(props.mode);
  // max value 1200 -> mobile.
  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  const [deviceMode, setDeviceMode] = React.useState(
    deviceModeValue ? "MOBILE" : "DESKTOP"
  );

  const [page, setPage] = React.useState(deviceModeValue ? 1 : 0);
  const [loading, setLoading] = React.useState(true);

  const rowsPerPage = 20;
  const [isSearchClickActive, setSearchClick] = React.useState(false);
  const service = new DisbursementRequestListService();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const closeDialogHandler = () => {
    setopenViewConfirmation(false);
    const dataValue = { ...responseData };
    dataValue.screenMode = props.screenMode;
    navigate("/stlap/home/disbursementView", {
      replace: true,
      state: dataValue,
    });
  };

  const cancelClickHandler = () => {
    setopenViewConfirmation(false);
  };

  const setRowsData = (totalTempRows) => {
    // filterConditionState.disbursementList = [...datarows].concat(totalTempRows);
    setFilterConditionState({ ...filterConditionState });
    if (JSON.stringify(totalTempRows) !== JSON.stringify(datarows)) {
      updateStateData(totalTempRows);
    }
  };

  useEffect(() => {
    const loadBranchNames = GetBranchDetails();
    setTotalBranchNames(loadBranchNames);
    setLoading(true);
    // on page load data load on ASC order of Application num by default.
    async function getAllDisbursementData() {
      filterConditionState.branchNames = loadBranchNames;
      let filterCondition = {};
      createFilterCondition(filterCondition, filterConditionState);
      filterCondition.offset = 0;
      filterCondition.pageSize = rowsPerPage;
      filterCondition.listScreenMode = listScreenMode;
      filterCondition.branch = loadBranchNames.map((name) => name.label);
      const branchValues = [...filterCondition.branch];
      const branchCodes = getSelectedBranchCodes(branchValues);
      filterCondition.branchCode = branchCodes;
      const allDisRequestList = await service.getAllDisbursementData(
        filterCondition
      );
      const totalTempRows = getDisbursementData(allDisRequestList.data.content);
      setTotalRecordsCount(allDisRequestList.data.totalElements);
      setTotalPageCount(allDisRequestList.data.totalPages);
      setRowsData(totalTempRows);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      // load the branch based data in case of single branch.
      if (loadBranchNames.length === 1) {
        loadDataonBranchChange(loadBranchNames[0].label);
      }
    }
    getAllDisbursementData();
    console.log("useEffect search click value : " + isSearchClickActive);
  }, [listScreenMode]);

  useLayoutEffect(() => {
    if (!(location.state === null)) {
      filterConditionState.branch = location.state.branch;
      updateFilterAutoFill(location.state, true);
      setFilterConditionState({ ...filterConditionState });
      // filter the data also, isbackfromdetailpage is true.
      filterData(location.state, true);
      // once back filter retain make location state back to null;
      location.state = null;
    }
    console.log(
      "use layout Effect search click value : " + isSearchClickActive
    );
  }, [datarows, listScreenMode]);

  const loadStatus = (value) => {
    return (
      <Chip
        label={value}
        component="div"
        sx={{
          color:
            value === "Paid"
              ? "darkgreen"
              : value === "Cancelled"
              ? "darkred"
              : value === "Modified"
              ? "blueviolet"
              : value === "Approved"
              ? "white"
              : value === "Approved , Cheque HandOver Pending" ||
                value === "Approved , Cheque Authourization Pending"
              ? "darkgreen"
              : value === "Requested , Pending For Nach"
              ? "Black"
              : "#004A92",
          bgcolor:
            value === "Paid"
              ? "lightgreen"
              : value === "Cancelled"
              ? "lightsalmon"
              : value === "Modified"
              ? "yellow"
              : value === "Approved"
              ? "darkgreen"
              : value === "Approved , Cheque HandOver Pending" ||
                value === "Approved , Cheque Authourization Pending"
              ? "lightgreen"
              : value === "Requested , Pending For Nach"
              ? "Orange"
              : "lightskyblue",
          width: "90%",
        }}
      />
    );
  };

  const handlePageChange = async (event, newPage) => {
    setPage(newPage);
    let filterCondition = {};
    createFilterCondition(filterCondition, filterConditionState);
    filterCondition.offset = Math.floor([...datarows].length / rowsPerPage);
    filterCondition.pageSize = rowsPerPage;
    filterCondition.listScreenMode = listScreenMode;
    // when branch is single & empty -> trigger all the branches.
    filterCondition.branch =
      filterCondition.branch.length === 1 &&
      filterCondition.branch[0] !== null &&
      filterCondition.branch[0] !== undefined &&
      filterCondition.branch[0] !== ""
        ? filterCondition.branch
        : filterConditionState.branchNames.map((name) => name.label);
    if ([...datarows].length < totalRecordsCount) {
      const branchValues = [...filterCondition.branch];
      const branchCodes = getSelectedBranchCodes(branchValues);
      filterCondition.branchCode = branchCodes;
      const allDisRequestList = await service.getAllDisbursementData(
        filterCondition
      );
      setTotalRecordsCount(allDisRequestList.data.totalElements);
      setTotalPageCount(allDisRequestList.data.totalPages);
      const totalTempRows = getDisbursementData(allDisRequestList.data.content);
      setRowsData(totalTempRows);
      const totalrecords = [...datarows].concat(totalTempRows);
      let offset = (newPage - 1) * rowsPerPage;
      setRows([...totalrecords].slice(offset, offset + rowsPerPage));
    } else {
      let offset = (newPage - 1) * rowsPerPage;
      setRows([...datarows].slice(offset, offset + rowsPerPage));
    }
  };

  const createFilterCondition = (filterCondition, filterConditionStateData) => {
    filterCondition.applicationNum = filterConditionStateData.applicationNum;
    filterCondition.branch = [
      filterConditionState.branchNames.length === 1
        ? filterConditionState.branchNames.at(0).label
        : filterConditionStateData.branch,
    ];
    // on single default branch add that value.
    filterConditionStateData.branch =
      filterConditionState.branchNames.length === 1
        ? filterConditionState.branchNames.at(0).label
        : filterConditionStateData.branch;
    filterCondition.applicantName = filterConditionStateData.customerName;
    filterCondition.requestNumber = filterConditionStateData.requestNumber;
    filterCondition.disbursementStatus =
      filterConditionStateData.disbursementStatus;
    filterCondition.disbursementDate =
      filterConditionStateData.disbursementDateFromValue;
  };

  const getSelectedBranchCodes = (branchValues) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValues = branchWithCodes
      .filter((branch) => branchValues.includes(branch.label))
      .map((branch) => branch.code);
    return branchCodeValues;
  };

  const resetFilterData = async (isBackfromDetailPage) => {
    filterConditionState.branch = "";
    updateFilterAutoFill(initialState, isBackfromDetailPage);
    filterConditionState.disbursementDateFromValue = null;
    setFilterConditionState({ ...filterConditionState });
    let filterCondition = {};
    createFilterCondition(filterCondition, initialState);
    filterCondition.offset = 0;
    filterCondition.pageSize = rowsPerPage;
    filterCondition.listScreenMode = listScreenMode;
    filterCondition.branch = branchNames.map((name) => name.label);
    const branchValues = [...filterCondition.branch];
    const branchCodes = getSelectedBranchCodes(branchValues);
    filterCondition.branchCode = branchCodes;
    const allDisRequestList = await service.getAllDisbursementData(
      filterCondition
    );
    const totalTempRows = getDisbursementData(allDisRequestList.data.content);
    setTotalRecordsCount(allDisRequestList.data.totalElements);
    setTotalPageCount(allDisRequestList.data.totalPages);
    setRowsData(totalTempRows);
    setPage(deviceModeValue ? 1 : 0);
  };

  const filterData = async (data, isBackfromDetailPage) => {
    // reset the data & get the data again.
    datarows.length = 0;
    let filterrows = [];
    if (isBackfromDetailPage) {
      // reset the autofill & retain back later.
      updateFilterAutoFill(initialState, isBackfromDetailPage);
    }

    // get the data from backend & use offset case also.
    let filterCondition = {};
    createFilterCondition(filterCondition, data);
    filterCondition.offset = Math.floor([...datarows].length / rowsPerPage);
    filterCondition.pageSize = rowsPerPage;
    filterCondition.listScreenMode = listScreenMode;
    filterCondition.column =
      sortConditions.length > 0 ? sortConditions[0].field : null;
    filterCondition.sort =
      sortConditions.length > 0 ? sortConditions[0].sort : null;
    // when branch is single & empty -> trigger all the branches.
    filterCondition.branch =
      filterCondition.branch.length === 1 &&
      filterCondition.branch[0] !== null &&
      filterCondition.branch[0] !== undefined &&
      filterCondition.branch[0] !== ""
        ? filterCondition.branch
        : data.branchNames.map((name) => name.label);
    const branchValues = [...filterCondition.branch];
    const branchCodes = getSelectedBranchCodes(branchValues);
    filterCondition.branchCode = branchCodes;
    const allDisRequestList = await service.getAllDisbursementData(
      filterCondition
    );
    const totalTempRows = getDisbursementData(allDisRequestList.data.content);
    setTotalRecordsCount(allDisRequestList.data.totalElements);
    setTotalPageCount(allDisRequestList.data.totalPages);
    setRowsData(totalTempRows);

    // Basic search tab
    if (data.branch && data.branch !== "") {
      filterrows = [...totalTempRows].filter(
        (row) => row.branch === data.branch
      );
      filterConditionState.branch = data.branch;
    } else {
      filterConditionState.branch = "";
    }
    if (data.applicationNum && data.applicationNum !== "") {
      filterrows = filterrows.filter(
        (row) => row.applicationNum === data.applicationNum
      );
      filterConditionState.applicationNum = data.applicationNum;
    } else {
      filterConditionState.applicationNum = "";
    }
    const applicantName = isBackfromDetailPage
      ? data.applicantName
      : data.customerName;
    if (applicantName && applicantName !== "") {
      filterrows = filterrows.filter(
        (row) => row.customerName === applicantName
      );
      filterConditionState.customerName = applicantName;
    } else {
      filterConditionState.customerName = "";
    }
    if (data.requestNumber && data.requestNumber !== "") {
      filterrows = filterrows.filter(
        (row) => row.requestNumber === data.requestNumber
      );
      // since this filter is for sancation list, so 1  requestNumber number has only one record.
      if (filterrows.length === 1) {
        updateFilterAutoFill(filterrows[0], isBackfromDetailPage);
      }
    } else {
      updateFilterAutoFill(initialState, isBackfromDetailPage);
    }
    if (data.disbursementStatus && data.disbursementStatus !== "") {
      filterrows = filterrows.filter(
        (row) => row.disbursementStatus === data.disbursementStatus
      );
      filterConditionState.disbursementStatus = data.disbursementStatus;
    } else {
      filterConditionState.disbursementStatus = "";
    }

    let disbursementDate = !isBackfromDetailPage
      ? data.disbursementDateFromValue
      : data.disbursementDate;
    disbursementDate = disbursementDate
      ? dayjs(disbursementDate).format("DD/MM/YYYY")
      : disbursementDate;
    if (disbursementDate && disbursementDate !== "") {
      filterrows = filterrows.filter(
        (row) => row.disbursementDate === disbursementDate
      );
      filterConditionState.disbursementDateFromValue = disbursementDate;
    } else {
      filterConditionState.disbursementDateFromValue = null;
    }

    // few more conditions yet to be added based on fields decided to tarequestNumrget need to add to dummy data.
    setRows(filterrows);
    setFilterConditionState({ ...filterConditionState });
    setTotalPageCount(
      filterrows.length % 10 !== 0
        ? Number(Number((filterrows.length / 10).toFixed()) + 1)
        : Number(Number((filterrows.length / 10).toFixed()))
    );
    setTotalRowsCount(filterrows.length);
    setPage(deviceModeValue ? 1 : 0);
  };

  const updateFilterAutoFill = (data, isBackfromDetailPage) => {
    // this method updates or removes other fields auto fill data to retain back
    filterConditionState.applicationNum = data.applicationNum;
    filterConditionState.customerName = data.customerName;
    filterConditionState.requestNumber = data.requestNumber;
    filterConditionState.disbursementStatus = data.disbursementStatus;
    const disbursementDate = dayjs(
      !isBackfromDetailPage
        ? data.disbursementDateFromValue
        : data.disbursementDate
    ).format("DD/MM/YYYY");
    filterConditionState.disbursementDateFromValue = disbursementDate;
  };

  const rowDoubleClickHandler = (event) => {
    // on request list or approval list had nothing to do on row click.
  };

  const gridLazyLoad = async (newPage) => {
    if (newPage >= page) {
      setPage(newPage);
      let filterCondition = {};
      createFilterCondition(filterCondition, filterConditionState);
      filterCondition.offset = Math.floor([...datarows].length / rowsPerPage);
      filterCondition.pageSize = rowsPerPage;
      filterCondition.listScreenMode = listScreenMode;
      filterCondition.column =
        sortConditions.length > 0 ? sortConditions[0].field : null;
      filterCondition.sort =
        sortConditions.length > 0 ? sortConditions[0].sort : null;
      // when branch is single & empty -> trigger all the branches.
      filterCondition.branch =
        filterCondition.branch.length === 1 &&
        filterCondition.branch[0] !== null &&
        filterCondition.branch[0] !== undefined &&
        filterCondition.branch[0] !== ""
          ? filterCondition.branch
          : filterConditionState.branchNames.map((name) => name.label);
      if ([...datarows].length < totalRecordsCount) {
        const branchValues = [...filterCondition.branch];
        const branchCodes = getSelectedBranchCodes(branchValues);
        filterCondition.branchCode = branchCodes;
        const allDisRequestList = await service.getAllDisbursementData(
          filterCondition
        );
        const totalTempRows = getDisbursementData(
          allDisRequestList.data.content
        );
        setTotalRecordsCount(allDisRequestList.data.totalElements);
        setTotalPageCount(allDisRequestList.data.totalPages);
        setRowsData(totalTempRows);
      }
    }
  };

  const updateStateData = (tempDataRows) => {
    const totalrecords = [...datarows].concat(tempDataRows);
    setRows([...totalrecords]);
    setdatarows([...totalrecords]);
    // setTotalPageCount(
    //   totalrecords.length % 10 !== 0
    //     ? Number(Number((totalrecords.length / 10).toFixed()) + 1)
    //     : Number(Number((totalrecords.length / 10).toFixed()))
    // );
    setTotalRowsCount(totalrecords.length);
  };

  const getDisbursementData = (disbreqlist) => {
    // let counter = 1;
    let tempDataRows = [];
    disbreqlist.map((disbursementRow) => {
      const dataMap1 = {
        // id: counter++,
        id: String(disbursementRow.transactionKey),
        requestNumber: String(disbursementRow.transactionKey),
        branch: disbursementRow.branch,
        branchCode: disbursementRow.branchCode,
        customerName: disbursementRow.applicantName,
        applicationNum: disbursementRow.applicationNum,
        applicationDate: disbursementRow.applicationDate,
        approvedAmount: disbursementRow.sanctionAmt,
        disbursementStatus: disbursementRow.requestStatus,
        customerType: disbursementRow.customerType,
        modifiedUser: disbursementRow.lastModifiedBy,
        modifiedDate: disbursementRow.lastModifiedDate,
        action: disbursementRow.requestStatus,
        totalDisbAmt: disbursementRow.totalDisbAmt,
        disbAmt: disbursementRow.disbAmt,
        approvedBy:
          disbursementRow.requestStatus === "Approved" ||
          disbursementRow.requestStatus ===
            "Approved , Cheque HandOver Pending" ||
          disbursementRow.requestStatus ===
            "Approved , Cheque Authourization Pending"
            ? disbursementRow.lastModifiedBy
            : "--------------",
        approvedOn:
          disbursementRow.requestStatus === "Approved" ||
          disbursementRow.requestStatus ===
            "Approved , Cheque HandOver Pending" ||
          disbursementRow.requestStatus ===
            "Approved , Cheque Authourization Pending"
            ? dayjs(disbursementRow.lastModifiedDate).format("DD/MM/YYYY")
            : "--------------",
        disbursementDate: dayjs(new Date(disbursementRow.dateOfDisb)).format(
          "DD/MM/YYYY"
        ),
        disbHeaderKey: disbursementRow.disbHeaderKey,
      };
      tempDataRows.push(dataMap1);
    });
    const totalDataRows =
      listScreenMode === "REQUESTLIST"
        ? [...tempDataRows].filter(
            (row) =>
              row.disbursementStatus !== "Approved" ||
              row.requestStatus !== "Approved , Cheque HandOver Pending" ||
              row.requestStatus !== "Approved , Cheque Authourization Pending"
          )
        : [...tempDataRows].filter(
            (row) =>
              row.disbursementStatus !== "Cancelled" &&
              row.disbursementStatus !== "Requested , Pending For Nach"
          );
    return totalDataRows;
  };

  const loadDataonBranchChange = async (branchValue) => {
    setdatarows([]);
    setRows([]);
    datarows.length = 0;
    if (branchValue) {
      // before response reset the rows also to empty.
      setPage(deviceMode === "MOBILE" ? 1 : 0);
      let filterCondition = {};
      createFilterCondition(filterCondition, initialState);
      filterCondition.offset = Math.floor([...datarows].length / rowsPerPage);
      filterCondition.pageSize = rowsPerPage;
      filterCondition.listScreenMode = listScreenMode;
      filterCondition.branch = [branchValue];
      const branchValues = [...filterCondition.branch];
      const branchCodes = getSelectedBranchCodes(branchValues);
      filterCondition.branchCode = branchCodes;
      const disreqlist = await service.getAllDisbursementData(filterCondition);
      const totalTempRows = getDisbursementData(disreqlist.data.content);
      setTotalPageCount(disreqlist.data.totalPages);
      setTotalRecordsCount(disreqlist.data.totalElements);
      // just to use for filter condition get all the records data.
      const branchWithCodes = GetBranchDetailsWithCode();
      const branchCodeValue = branchWithCodes.find((branch) => {
        return branch.label === branchValue;
      });
      const allDisbDataResponse = await service.getDisbursementDataByBranch(
        branchCodeValue
      );
      const allDisbDataRows = getDisbursementData(allDisbDataResponse.data);
      filterConditionState.disbursementList = [...allDisbDataRows];
      setRowsData(totalTempRows);
      dispatch(BranchAction.updateInitialLoad(false));
      dispatch(BranchAction.updateHeaderBranchDetails(branchValue));
    } else {
      // when it was null was like reset filter, so retain the last set of data rows with all DB hit.
      datarows.length = 0;
      resetFilterData(false);
    }
  };

  const onSortModelChange = async (event) => {
    if (event.length > 0) {
      setSortConditions(event);
      setdatarows([]);
      setRows([]);
      datarows.length = 0;
      // before response reset the rows also to empty.
      setPage(deviceMode === "MOBILE" ? 1 : 0);
      let filterCondition = {};
      createFilterCondition(filterCondition, filterConditionState);
      filterCondition.offset = Math.floor([...datarows].length / rowsPerPage);
      filterCondition.pageSize = rowsPerPage;
      filterCondition.listScreenMode = listScreenMode;
      filterCondition.column = event[0].field;
      filterCondition.sort = String(event[0].sort).toUpperCase();
      // when branch is single & empty -> trigger all the branches.
      filterCondition.branch =
        filterCondition.branch.length === 1 &&
        filterCondition.branch[0] !== null &&
        filterCondition.branch[0] !== undefined &&
        filterCondition.branch[0] !== ""
          ? filterCondition.branch
          : filterConditionState.branchNames.map((name) => name.label);
      const branchValues = [...filterCondition.branch];
      const branchCodes = getSelectedBranchCodes(branchValues);
      filterCondition.branchCode = branchCodes;
      const disreqlist = await service.getAllDisbursementData(filterCondition);
      const totalTempRows = getDisbursementData(disreqlist.data.content);
      setTotalPageCount(disreqlist.data.totalPages);
      setTotalRecordsCount(disreqlist.data.totalElements);
      setRowsData(totalTempRows);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={openViewConfirmation}
        onClose={closeDialogHandler}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography>
            This Record is Being Edited by Other User.
            <br />
            Click OK to Navigate to View Screen.
          </Typography>
        </DialogTitle>

        <DialogActions>
          <Tooltip title="Ctrl+K" placement="top">
            <Button autoFocus onClick={closeDialogHandler} ref={okRef}>
              OK
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button onClick={cancelClickHandler} ref={cancelRef}>
              Cancel
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <FilterCondition
          initialState={filterConditionState}
          title="Disbursement Information"
          onSearchButtonClick={(data) => {
            filterData(data, false);
            setSearchClick(true);
          }}
          onClearButtonClick={() => {
            datarows.length = 0;
            resetFilterData(false);
            setSearchClick(false);
          }}
          setAccordianOpen={setAccordianOpen}
          mode={"Search"}
          disDetailPage={false}
          initialOpen={true}
          onBranchChange={loadDataonBranchChange}
          listScreenMode={listScreenMode}
          datarows={rows}
          searchButtonRef={searchButtonRef}
          clearRef={clearRef}
        />
        {useMediaQuery("(min-width:1200px)") && (
          <React.Fragment>
            {loading && (
              <Box sx={{ backgroundColor: "white", minHeight: "320px" }}>
                <Skeleton
                  variant="rounded"
                  animation="wave"
                  width="100%"
                  height={
                    window.innerHeight > 650
                      ? window.innerHeight / 1.8
                      : "260px"
                  }
                />
              </Box>
            )}
            {!loading && (
              <CustomDataGrid
                noDataMessage="No Disbursement Data."
                noDataOnFilterMessage="No Disbursement Data on Applied Filter."
                rows={rows}
                columns={columns}
                // loading={rows.length === 0}
                pageSize={10}
                pageSizeOptions={[10]}
                rowHeight={40}
                pageValue={page}
                rowDoubleClickHandler={rowDoubleClickHandler}
                gridLazyLoad={gridLazyLoad}
                columnVisibilityModel={columnVisibilityModel}
                sortingMode="server"
                onSortModelChange={onSortModelChange}
              />
            )}
          </React.Fragment>
        )}
        {useMediaQuery("(max-width:1200px)") && (
          <React.Fragment>
            <Grid
              container
              item
              direction="row"
              alignItems="flex-end"
              justifyContent="flex-end"
              sx={{ height: "60px", bgcolor: "white" }}
            >
              {totalRecordsCount > 10 && (
                <Typography
                  sx={{
                    mr: 2,
                    color: "#004A92",
                    fontWeight: 700,
                  }}
                >
                  {"Page Max Records : " + rowsPerPage}
                </Typography>
              )}
              <Typography
                padding="1px"
                sx={{ color: "#004A92", fontWeight: 700 }}
              >
                {"Total Records : " + totalRecordsCount}
              </Typography>
              <Pagination
                count={totalPageCount}
                color="primary"
                onChange={handlePageChange}
                page={page}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBack, next: ArrowForward }}
                    {...item}
                  />
                )}
              />
            </Grid>
            <Grid container>
              <Box
                sx={{
                  height: accordianOpen
                    ? window.innerHeight - 540
                    : window.innerHeight - 250,
                  overflow: "auto",
                  flex: "1 auto",
                }}
              >
                {rows.map((row, index) => (
                  <React.Fragment>
                    <Grid container direction="column" sx={{ flex: "1 auto" }}>
                      <Card>
                        <CardHeader
                          action={
                            <React.Fragment>
                              {
                                <LoadActionBtn
                                  record={row}
                                  setResponseData={setResponseData}
                                  setopenViewConfirmation={
                                    setopenViewConfirmation
                                  }
                                  listScreenMode={listScreenMode}
                                />
                              }
                            </React.Fragment>
                          }
                          subheader={
                            "Application Number : " + row.applicationNum
                          }
                          subheaderTypographyProps={{
                            color: "#004A92",
                            fontWeight: "700",
                          }}
                          sx={{
                            textAlign: "left",
                            padding: "16px 16px 0px 16px !important",
                          }}
                        />
                        <CardContent sx={{}}>
                          <Grid
                            container
                            item
                            direction="column"
                            alignItems="flex-start"
                            justifyContent="flex-start"
                            sx={{}}
                          >
                            <Grid
                              container
                              direction="row"
                              alignItems="flex-start"
                              justifyContent="flex-start"
                            >
                              {/* <Grid item xs={7} md={5}>
                              <Typography padding="1px">
                                {"Request Number"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${row.requestNumber}`}
                            </Grid> */}
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Branch Name"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${row.branch}`}
                              </Grid>
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Applicant Name"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${row.customerName}`}
                              </Grid>
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Disbursement Amount"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${parseInt(row.disbAmt).toLocaleString(
                                  "en-IN"
                                )}`}
                              </Grid>
                              {/* <Grid item xs={7} md={5}>
                              <Typography padding="1px">
                                {"Disbursement Date"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${row.disbursementDate}`}
                            </Grid> */}
                              {props.mode !== "REQUESTLIST" && (
                                <>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Approved By"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` :  ${row.approvedBy}`}
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Approved On"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` :  ${row.approvedOn}`}
                                  </Grid>
                                </>
                              )}
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            item
                            direction="row"
                            alignItems="flex-end"
                            justifyContent="flex-end"
                          >
                            <Typography sx={{ width: "80%" }}>
                              {loadStatus(row.disbursementStatus)}
                            </Typography>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Divider />
                  </React.Fragment>
                ))}
                {rows.length === 0 && (
                  <NoDataFound
                    message={"No Disbursement Record Found."}
                    imageStyle={{
                      marginTop:
                        accordianOpen && window.innerHeight < 1000
                          ? "20px"
                          : "20%",
                    }}
                  />
                )}
              </Box>
            </Grid>
          </React.Fragment>
        )}
      </Box>
      <StlapFooter />
    </React.Fragment>
  );
}

const LoadActionBtn = (props) => {
  const dispatch = useDispatch();
  const viewRef = useRef(null);
  const modifyRef = useRef(null);
  const deleteRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);

  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      viewRef: viewRef,
      modifyRef: modifyRef,
      deleteRef: deleteRef,
    };
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "disbursementLoadActionBtn",
        })
      );
      //}
    }
  };
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "disbursementLoadActionBtn",
        })
      );
    }
  };
  const service = new DisbursementRequestListService();
  const [record, setRecord] = React.useState(props.record);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [listScreenMode, setListScreenMode] = React.useState(
    props.listScreenMode
  );
  const open = Boolean(anchorEl);
  const req_mod_options = ["View", "Modify", "Cancel"];
  const navigate = useNavigate();
  //using dispatch
  const dispatchRedux = useDispatch();
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useLayoutEffect(() => {
    // console.log("layout effect");
    // console.log(props.record);
  }, [props.record]);

  useEffect(() => {
    // console.log("effect");
    // console.log(props.record);
  }, [props.record]);

  const loadDetailPage = async (record, url, mode) => {
    const response = await service.getDisbursementData({
      disbHeaderKey: record.disbHeaderKey,
      screenMode: mode,
    });
    if (response.data.editLock && mode !== "VIEW") {
      // change the structure of the balance transfer grid.
      let recordData = { ...response.data };
      let balanceTransferRecords = recordData.disbursementFavours;
      balanceTransferRecords = [...balanceTransferRecords].map((row) => {
        let record = { ...row };
        record.id = record.disbAccountKey;
        record.amount = record.totalDisbAmt;
        record.disbAmt = record.disbAmt;
        record.favouringName = record.accHoldrName;
        record.bankBranchShflBank = record.bankBranch;
        if (record.docName && record.docData) {
          record.handOverFile = record.docName;
          const arrayFileString = String(record.docData).split(";base64,");
          const base64StringValue = arrayFileString[1];
          const fileType = arrayFileString[0].split("data:");
          const uploadedFile = ConvertBase64ToFile(
            base64StringValue,
            record.docName,
            fileType[1]
          );
          const fileData = Object.assign(uploadedFile, {
            preview: URL.createObjectURL(uploadedFile),
          });
          record.handOverFiles = [fileData];
        } else {
          record.handOverFile = null;
          record.handOverFiles = [];
        }
        return record;
      });
      recordData.disbursementFavours = balanceTransferRecords;

      dispatchRedux(
        DisbursementBalanceTransferReducerAction.updateGridRows(
          balanceTransferRecords
        )
      );
      dispatchRedux(
        DisbursementBalanceTransferReducerAction.updateLoanType(
          recordData.loanType
        )
      );
      props.setResponseData(recordData);
      props.setopenViewConfirmation(true);
    } else {
      let recordData = { ...response.data };
      recordData.screenMode = props.screenMode;
      // change the structure of the balance transfer grid.
      let balanceTransferRecords = recordData.disbursementFavours;
      balanceTransferRecords = [...balanceTransferRecords].map((row) => {
        let record = { ...row };
        record.id = record.disbAccountKey;
        record.amount = record.totalDisbAmt;
        record.disbAmt = record.disbAmt;
        record.favouringName = record.accHoldrName;
        record.bankBranchShflBank = record.bankBranch;
        if (record.docName && record.docData) {
          record.handOverFile = record.docName;
          const arrayFileString = String(record.docData).split(";base64,");
          const base64StringValue = arrayFileString[1];
          const fileType = arrayFileString[0].split("data:");
          const uploadedFile = ConvertBase64ToFile(
            base64StringValue,
            record.docName,
            fileType[1]
          );
          const fileData = Object.assign(uploadedFile, {
            preview: URL.createObjectURL(uploadedFile),
          });
          record.handOverFiles = [fileData];
        } else {
          record.handOverFile = null;
          record.handOverFiles = [];
        }
        return record;
      });
      recordData.disbursementFavours = balanceTransferRecords;

      dispatchRedux(
        DisbursementBalanceTransferReducerAction.updateGridRows(
          balanceTransferRecords
        )
      );
      if (mode === "MODIFY") {
        dispatchRedux(
          DisbursementBalanceTransferReducerAction.updateValidGridRecordsAsNonEditable(
            balanceTransferRecords
          )
        );
      }
      dispatchRedux(
        DisbursementBalanceTransferReducerAction.updateLoanType(
          recordData.loanType
        )
      );
      navigate(url, {
        replace: true,
        state: recordData,
      });
    }
  };

  const handleIconClick = (value, record) => {
    handleClose();
    switch (value) {
      case "View":
        loadDetailPage(record, "/stlap/home/disbursementView", "VIEW");
        break;
      case "Modify":
        loadDetailPage(record, "/stlap/home/disbursementModify", "MODIFY");
        break;
      case "Cancel":
        loadDetailPage(record, "/stlap/home/disbursementCancel", "CANCEL");
        break;
      case "Approve":
        loadDetailPage(record, "/stlap/home/disbursementApprove", "APPROVE");
    }
  };

  const ITEM_HEIGHT = 48;
  return (
    <React.Fragment>
      {record.disbursementStatus === "Paid" ||
      record.disbursementStatus === "Cancelled" ||
      record.disbursementStatus === "Approved" ||
      record.disbursementStatus === "Approved , Cheque HandOver Pending" ||
      record.disbursementStatus ===
        "Approved , Cheque Authourization Pending" ||
      record.disbursementStatus === "Loan Closed" ? (
        <React.Fragment>
          {record.disbursementStatus === "Approved , Cheque HandOver Pending" ||
          record.disbursementStatus ===
            "Approved , Cheque Authourization Pending" ? (
            <Tooltip title="Edit For Cheque HandOver or Cheque Authourization">
              <IconButton onClick={() => handleIconClick("Approve", record)}>
                <Edit sx={{ color: "#004A92", fontWeight: 700 }} />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="View">
              <IconButton onClick={() => handleIconClick("View", record)}>
                <Preview sx={{ color: "#004A92", fontWeight: 700 }} />
              </IconButton>
            </Tooltip>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          {listScreenMode === "REQUESTLIST" ? (
            <div>
              <Tooltip title="More Actions">
                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-controls={open ? "long-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleMenuClick}
                >
                  <MoreVert sx={{ color: "#004A92", fontWeight: 700 }} />
                </IconButton>
              </Tooltip>
              <Menu
                id="long-menu"
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: "100px",
                  },
                }}
              >
                {req_mod_options.map((option, index) => (
                  <MenuItem
                    key={option}
                    selected={option === "Pyxis"}
                    onClick={() => handleIconClick(option, record)}
                    ref={
                      (option === "View" && viewRef) ||
                      (option === "Modify" && modifyRef) ||
                      (option === "Cancel" && deleteRef)
                    }
                  >
                    <IconButton size="small">
                      {(() => {
                        switch (index) {
                          case 0:
                            return (
                              <Tooltip title="Ctrl+E" placement="right">
                                <Preview
                                  fontSize="small"
                                  sx={{ color: "#004A92", fontWeight: 700 }}
                                />
                              </Tooltip>
                            );
                          case 1:
                            return (
                              <Tooltip title="Ctrl+M" placement="right">
                                <Edit
                                  fontSize="small"
                                  sx={{ color: "#004A92", fontWeight: 700 }}
                                />
                              </Tooltip>
                            );
                          case 2:
                            return (
                              <Tooltip title="Ctrl+B" placement="right">
                                <CancelScheduleSend
                                  fontSize="small"
                                  sx={{ color: "#004A92", fontWeight: 700 }}
                                />
                              </Tooltip>
                            );
                        }
                      })()}
                    </IconButton>
                    <Typography
                      color="#004A92"
                      variant="inherit"
                      component="div"
                      fontSize="14px"
                      fontWeight="inherit"
                    >
                      {option}
                    </Typography>
                  </MenuItem>
                ))}
              </Menu>
            </div>
          ) : (
            <Tooltip title="Approve">
              <IconButton onClick={() => handleIconClick("Approve", record)}>
                <VerifiedOutlined sx={{ color: "#004A92", fontWeight: 700 }} />
              </IconButton>
            </Tooltip>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
